type Country = string;
type LangCode = string;
type LangName = string;
type SearchString = string;
type LocalizationHandler = string;
type PronunciationLocale = string;

type LocaleData = [
  Country,
  LangCode,
  LangName,
  SearchString,
  LocalizationHandler,
  PronunciationLocale,
];

interface NestedLanguage {
  isoCode: string;
  name: string;
  locales: LocaleData[];
  defaultLocale: string;
  welcomeBackMessage: string;
}

export const nestedLanguageList: NestedLanguage[] = [
  {
    isoCode: "en",
    name: "English",
    defaultLocale: "US",
    welcomeBackMessage: "Welcome back! Ready to continue?",
    locales: [
      ["US", "en-US", "American English", "American English", "language.americanEnglish", "en-US"],
      [
        "GB",
        "en-GB",
        "British English",
        "British English, England, UK",
        "language.britishEnglish",
        "en-GB",
      ],
      [
        "EI",
        "en-IE",
        "Irish English",
        "Irish English, Ireland, Hiberno",
        "language.irishEnglish",
        "en-GB",
      ],
      [
        "AU",
        "en-AU",
        "Australian English",
        "Australian English, Australia",
        "language.australianEnglish",
        "en-AU",
      ],
      [
        "NZ",
        "en-NZ",
        "New Zealand English",
        "New Zealand English, New Zealand",
        "language.newZealandEnglish",
        "en-AU",
      ],
      [
        "CE",
        "en-CA",
        "Canadian English",
        "Canadian English, Canada",
        "language.canadianEnglish",
        "en-CA",
      ],
      ["ED", "en-IN", "Indian English", "Indian English, India", "language.indianEnglish", "en-IN"],
    ],
  },
  {
    isoCode: "fr",
    name: "Français",
    defaultLocale: "FR",
    welcomeBackMessage: "Bon retour ! Prêt à continuer ?",
    locales: [
      ["FR", "fr-FR", "Français", "Français, French, France", "language.french", "fr-FR"],
      [
        "CA",
        "fr-CA",
        "Français canadien",
        "Français, French, Canada",
        "language.canadianFrench",
        "fr-CA",
      ],
      [
        "FC",
        "fr-CH",
        "Français suisse",
        "Français, French, Switzerland",
        "language.swissFrench",
        "fr-FR",
      ],
      [
        "BE",
        "fr-BE",
        "Français belge",
        "Français, French, Belgium",
        "language.belgianFrench",
        "fr-FR",
      ],
    ],
  },
  {
    isoCode: "de",
    name: "Deutsch",
    defaultLocale: "DE",
    welcomeBackMessage: "Willkommen zurück! Bereit weiterzumachen?",
    locales: [
      [
        "DE",
        "de-DE",
        "Deutsch",
        "Deutsch (Deutschland), German, Germany",
        "language.german",
        "de-DE",
      ],
      [
        "AT",
        "de-AT",
        "Österreichisches Deutsch",
        "Österreichisches Deutsch, German, Austria",
        "language.austrianGerman",
        "de-DE",
      ],
      [
        "CH",
        "de-CH",
        "Schweizer Hochdeutsch",
        "Schweizer Hochdeutsch, German, Germany",
        "language.swissGerman",
        "de-DE",
      ],
    ],
  },
  {
    isoCode: "es",
    name: "Español",
    defaultLocale: "MX",
    welcomeBackMessage: "¡Bienvenido de vuelta! ¿Listo para continuar?",
    locales: [
      [
        "ES",
        "es-ES",
        "Español de España",
        "Español, Spanish, Spain",
        "language.spanishSpain",
        "es-ES",
      ],
      [
        "MX",
        "es-MX",
        "Español de México",
        "Español, Spanish, Mexico",
        "language.spanishMexico",
        "es-MX",
      ],
      [
        "AR",
        "es-AR",
        "Español de Argentina",
        "Español, Spanish, Argentina",
        "language.spanishArgentina",
        "es-AR",
      ],
      [
        "BO",
        "es-BO",
        "Español de Bolivia",
        "Español, Spanish, Bolivia",
        "language.spanishBolivia",
        "es-AR",
      ],
      [
        "CL",
        "es-CL",
        "Español de Chile",
        "Español, Spanish, Chile",
        "language.spanishChile",
        "es-AR",
      ],
      [
        "CO",
        "es-CO",
        "Español de Colombia",
        "Español, Spanish, Colombia",
        "language.spanishColombia",
        "es-MX",
      ],
      [
        "CR",
        "es-CR",
        "Español de Costa Rica",
        "Español, Spanish, Costa Rica",
        "language.spanishCostaRica",
        "es-MX",
      ],
      ["CU", "es-CU", "Español de Cuba", "Español, Spanish, Cuba", "language.spanishCuba", "es-MX"],
      [
        "EC",
        "es-EC",
        "Español de Ecuador",
        "Español, Spanish, Ecuador",
        "language.spanishEcuador",
        "es-MX",
      ],
      [
        "SV",
        "es-SV",
        "Español de El Salvador",
        "Español, Spanish, El Salvador",
        "language.spanishElSalvador",
        "es-MX",
      ],
      [
        "GT",
        "es-GT",
        "Español de Guatemala",
        "Español, Spanish, Guatemala",
        "language.spanishGuatemala",
        "es-MX",
      ],
      [
        "GQ",
        "es-GQ",
        "Español de Guinea Ecuatorial",
        "Español, Spanish, Equatorial Guinea",
        "language.spanishEquatorialGuinea",
        "es-ES",
      ],
      [
        "UE",
        "es-US",
        "Español de Estados Unidos",
        "Español, Spanish, United States",
        "language.spanishUnitedStates",
        "es-MX",
      ],
      [
        "HN",
        "es-HN",
        "Español de Honduras",
        "Español, Spanish, Honduras",
        "language.spanishHonduras",
        "es-MX",
      ],
      [
        "NI",
        "es-NI",
        "Español de Nicaragua",
        "Español, Spanish, Nicaragua",
        "language.spanishNicaragua",
        "es-MX",
      ],
      [
        "PA",
        "es-PA",
        "Español de Panamá",
        "Español, Spanish, Panama",
        "language.spanishPanama",
        "es-MX",
      ],
      [
        "PY",
        "es-PY",
        "Español de Paraguay",
        "Español, Spanish, Paraguay",
        "language.spanishParaguay",
        "es-AR",
      ],
      ["PE", "es-PE", "Español de Perú", "Español, Spanish, Peru", "language.spanishPeru", "es-ES"],
      [
        "PR",
        "es-PR",
        "Español de Puerto Rico",
        "Español, Spanish, Puerto Rico",
        "language.spanishPuertoRico",
        "es-MX",
      ],
      [
        "DO",
        "es-DO",
        "Español de República Dominicana",
        "Español, Spanish, Dominican Republic",
        "language.spanishDominicanRepublic",
        "es-MX",
      ],
      [
        "UY",
        "es-UY",
        "Español de Uruguay",
        "Español, Spanish, Uruguay",
        "language.spanishUruguay",
        "es-AR",
      ],
      [
        "VE",
        "es-VE",
        "Español de Venezuela",
        "Español, Spanish, Venezuela",
        "language.spanishVenezuela",
        "es-MX",
      ],
    ],
  },
  {
    isoCode: "pt",
    name: "Português",
    defaultLocale: "BR",
    welcomeBackMessage: "Bem-vindo de volta! Pronto para continuar?",
    locales: [
      [
        "BR",
        "pt-BR",
        "Português",
        "Português, Portuguese, Brazil",
        "language.portugueseBrazil",
        "pt-BR",
      ],
      [
        "PT",
        "pt-PT",
        "Português",
        "Português, Portuguese, Portugal",
        "language.portuguesePortugal",
        "pt-PT",
      ],
    ],
  },
  {
    isoCode: "zh",
    name: "中文",
    defaultLocale: "CN",
    welcomeBackMessage: "欢迎回来！准备好继续了吗？",
    locales: [
      [
        "CN",
        "zh-CN",
        "中文（中国）",
        "中文（中国）, Chinese, China",
        "language.chineseSimplified",
        "zh-CN",
      ],
      [
        "TW",
        "zh-TW",
        "中文（台灣）",
        "中文（台灣）, Taiwanese Mandarin, Taiwan, Chinese, China, Traditional",
        "language.chineseTraditional",
        "zh-TW",
      ],
      [
        "HK",
        "zh-HK",
        "中文（香港）",
        "Cantonese, Hong Kong, Chinese, China",
        "language.chineseHongKong",
        "zh-HK",
      ],
    ],
  },
  {
    isoCode: "ar",
    name: "العربية",
    defaultLocale: "EG",
    welcomeBackMessage: "مرحباً بعودتك! هل أنت مستعد للمتابعة؟",
    locales: [
      ["EG", "ar-EG", "العربية", "العربية (مصر), Arabic, Egypt", "language.arabicEgypt", "ar-EG"],
      [
        "JO",
        "ar-JO",
        "العربية",
        "العربية (الأردن), Arabic, Jordan",
        "language.arabicJordan",
        "ar-SA",
      ],
      [
        "AE",
        "ar-AE",
        "العربية",
        "العربية (الإمارات العربية المتحدة), Arabic, United Arab Emirates",
        "language.arabicUAE",
        "ar-SA",
      ],
      [
        "BH",
        "ar-BH",
        "العربية",
        "العربية (البحرين), Arabic, Bahrain",
        "language.arabicBahrain",
        "ar-SA",
      ],
      [
        "DZ",
        "ar-DZ",
        "العربية",
        "العربية (الجزائر), Arabic, Algeria",
        "language.arabicAlgeria",
        "ar-SA",
      ],
      ["IQ", "ar-IQ", "العربية", "العربية (العراق), Arabic, Iraq", "language.arabicIraq", "ar-SA"],
      [
        "KW",
        "ar-KW",
        "العربية",
        "العربية (الكويت), Arabic, Kuwait",
        "language.arabicKuwait",
        "ar-SA",
      ],
      [
        "MA",
        "ar-MA",
        "العربية",
        "العربية (المغرب), Arabic, Morocco",
        "language.arabicMorocco",
        "ar-SA",
      ],
      [
        "SA",
        "ar-SA",
        "العربية",
        "العربية (المملكة العربية السعودية), Arabic, Saudi Arabia",
        "language.arabicSaudiArabia",
        "ar-SA",
      ],
      ["YE", "ar-YE", "العربية", "العربية (اليمن), Arabic, Yemen", "language.arabicYemen", "ar-SA"],
      [
        "TN",
        "ar-TN",
        "العربية",
        "العربية (تونس), Arabic, Tunisia",
        "language.arabicTunisia",
        "ar-SA",
      ],
      ["SY", "ar-SY", "العربية", "العربية (سوريا), Arabic, Syria", "language.arabicSyria", "ar-SA"],
      ["OM", "ar-OM", "العربية", "العربية (عُمان), Arabic, Oman", "language.arabicOman", "ar-SA"],
      ["QA", "ar-QA", "العربية", "العربية (قطر), Arabic, Qatar", "language.arabicQatar", "ar-SA"],
      [
        "LB",
        "ar-LB",
        "العربية",
        "العربية (لبنان), Arabic, Lebanon",
        "language.arabicLebanon",
        "ar-SA",
      ],
      ["LY", "ar-LY", "العربية", "العربية (ليبيا), Arabic, Libya", "language.arabicLibya", "ar-SA"],
    ],
  },
  {
    isoCode: "nl",
    name: "Nederlands",
    defaultLocale: "NL",
    welcomeBackMessage: "Welkom terug! Klaar om verder te gaan?",
    locales: [
      ["NL", "nl-NL", "Nederlands", "Nederlands (Nederland)", "language.dutch", "nl-NL"],
      ["FL", "nl-BE", "Vlaams", "Vlaams", "language.flemish", "nl-NL"], // Att.: consider create Belgium separately and then include fr-BE as well.
    ],
  },
  {
    isoCode: "sw",
    name: "Kiswahili",
    defaultLocale: "KE",
    welcomeBackMessage: "Karibu tena! Uko tayari kuendelea?",
    locales: [
      ["KE", "sw-KE", "Kiswahili", "Kiswahili (Kenya)", "language.swahiliKenya", "sw-KE"], // pronunciation locale not supported
      ["TZ", "sw-TZ", "Kiswahili", "Kiswahili (Tanzania)", "language.swahiliTanzania", "sw-TZ"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "hi",
    name: "हिन्दी",
    defaultLocale: "IN",
    welcomeBackMessage: "वापसी पर स्वागत है! जारी रखने के लिए तैयार हैं?",
    locales: [["IN", "hi-IN", "हिन्दी", "हिन्दी (भारत), Hindi, India", "language.hindi", "hi-IN"]],
  },
  {
    isoCode: "af",
    name: "Afrikaans",
    defaultLocale: "ZA",
    welcomeBackMessage: "Welkom terug! Gereed om voort te gaan?",
    locales: [
      ["ZA", "af-ZA", "Afrikaans", "Afrikaans (Suid-Afrika)", "language.afrikaans", "af-ZA"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "sq",
    name: "Albanian",
    defaultLocale: "AL",
    welcomeBackMessage: "Mirë se u kthyet! Gati të vazhdojmë?",
    locales: [
      ["AL", "sq-AL", "Albanian", "Albanian (Albania)", "language.albanian", "sq-AL"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "az",
    name: "Azərbaycan",
    defaultLocale: "AZ",
    welcomeBackMessage: "Yenidən xoş gəlmisiniz! Davam etməyə hazırsınız?",
    locales: [
      ["AZ", "az-AZ", "Azərbaycan", "Azərbaycan (Azerbaijan)", "language.azerbaijani", "az-AZ"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "eu",
    name: "Basque",
    defaultLocale: "EU",
    welcomeBackMessage: "Ongietorri berriz! Jarraitzeari zara?",
    locales: [["EU", "eu-ES", "Basque", "Basque (Spain)", "language.basque", "es-ES"]],
  },
  {
    isoCode: "bs",
    name: "Bosanski",
    defaultLocale: "BA",
    welcomeBackMessage: "Dobro došli nazad! Spremni za nastavak?",
    locales: [
      ["BA", "bs-BA", "Bosanski", "Bosanski (Bosnia & Herzegovina)", "language.bosnian", "bs-BA"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "ca",
    name: "Català",
    defaultLocale: "CT",
    welcomeBackMessage: "Benvingut de nou! Preparat per continuar?",
    locales: [
      [
        "CT",
        "ca-ES",
        "Català",
        "Català (Espanya) Catalonia, Catalan, Spain",
        "language.catalan",
        "ca-ES",
      ],
    ],
  },
  {
    isoCode: "cs",
    name: "Čeština",
    defaultLocale: "CZ",
    welcomeBackMessage: "Vítejte zpět! Připraveni pokračovat?",
    locales: [
      ["CZ", "cs-CZ", "Čeština", "Čeština (Česko)", "language.czech", "cs-CZ"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "da",
    name: "Dansk",
    defaultLocale: "DK",
    welcomeBackMessage: "Velkommen tilbage! Klar til at fortsætte?",
    locales: [["DK", "da-DK", "Dansk", "Dansk (Danmark)", "language.danish", "da-DK"]],
  },
  {
    isoCode: "et",
    name: "Eesti",
    defaultLocale: "EE",
    welcomeBackMessage: "Tere tulemast tagasi! Valmis jätkama?",
    locales: [
      ["EE", "et-EE", "Eesti", "Eesti (Eesti)", "language.estonian", "et-EE"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "fil",
    name: "Filipino",
    defaultLocale: "PH",
    welcomeBackMessage: "Maligayang pagbabalik! Handa na ba tayong magpatuloy?",
    locales: [
      ["PH", "fil-PH", "Filipino", "Filipino (Pilipinas)", "language.filipino", "fil-PH"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "gl",
    name: "Galician",
    defaultLocale: "GC",
    welcomeBackMessage: "Benvido de volta! Preparado para continuar?",
    locales: [["GC", "gl-ES", "Galician", "Galician (Spain)", "language.galician", "es-ES"]],
  },
  {
    isoCode: "ka",
    name: "Georgian",
    defaultLocale: "GE",
    welcomeBackMessage: "მოგესალმებით უკან! მზად ხართ გაგრძელებისთვის?",
    locales: [
      ["GE", "ka-GE", "Georgian", "Georgian (Georgia)", "language.georgian", "ka-GE"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "hr",
    name: "Hrvatski",
    defaultLocale: "HR",
    welcomeBackMessage: "Dobro došli natrag! Spremni za nastavak?",
    locales: [
      ["HR", "hr-HR", "Hrvatski", "Hrvatski (Hrvatska)", "language.croatian", "hr-HR"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "is",
    name: "Icelandic",
    defaultLocale: "IS",
    welcomeBackMessage: "Velkomin tilbaka! Tilbúin að halda áfram?",
    locales: [
      ["IS", "is-IS", "Icelandic", "Icelandic (Iceland)", "language.icelandic", "is-IS"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "id",
    name: "Indonesian",
    defaultLocale: "ID",
    welcomeBackMessage: "Selamat datang kembali! Siap untuk melanjutkan?",
    locales: [
      ["ID", "id-ID", "Indonesian", "Indonesian (Indonesia)", "language.indonesian", "id-ID"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "ga",
    name: "Irish",
    defaultLocale: "IE",
    welcomeBackMessage: "Fáilte ar ais! Réidh le leanúint ar aghaidh?",
    locales: [
      ["IE", "ga-IE", "Irish", "Irish (Ireland)", "language.irish", "ga-IE"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "it",
    name: "Italiano",
    defaultLocale: "IT",
    welcomeBackMessage: "Bentornato! Pronto a continuare?",
    locales: [["IT", "it-IT", "Italiano", "Italiano (Italia)", "language.italian", "it-IT"]],
  },
  {
    isoCode: "jv",
    name: "Javanese",
    defaultLocale: "JV",
    welcomeBackMessage: "Sugeng rawuh maneh! Siap terusake?",
    locales: [
      [
        "JV",
        "jv-ID",
        "Javanese",
        "Javanese (Indonesia), Java, Indonesian",
        "language.javanese",
        "jv-ID",
      ], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "kk",
    name: "Kazakh",
    defaultLocale: "KZ",
    welcomeBackMessage: "Қайтып келуіңізбен! Жалғастыруға дайынсыз ба?",
    locales: [
      ["KZ", "kk-KZ", "Kazakh", "Kazakh (Kazakhstan)", "language.kazakh", "kk-KZ"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "lv",
    name: "Latviešu",
    defaultLocale: "LV",
    welcomeBackMessage: "Laipni lūdzam atpakaļ! Gatavs turpināt?",
    locales: [
      ["LV", "lv-LV", "Latviešu", "Latviešu (Latvija)", "language.latvian", "lv-LV"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "lt",
    name: "Lietuvių",
    defaultLocale: "LT",
    welcomeBackMessage: "Sveiki sugrįžę! Pasiruošęs tęsti?",
    locales: [
      ["LT", "lt-LT", "Lietuvių", "Lietuvių (Lietuva)", "language.lithuanian", "lt-LT"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "mk",
    name: "Macedonian",
    defaultLocale: "MK",
    welcomeBackMessage: "Добродојдовте назад! Спремни да продолжиме?",
    locales: [
      ["MK", "mk-MK", "Macedonian", "Macedonian (North Macedonia)", "language.macedonian", "mk-MK"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "hu",
    name: "Magyar",
    defaultLocale: "HU",
    welcomeBackMessage: "Üdvözöljük vissza! Készen áll a folytatásra?",
    locales: [
      [
        "HU",
        "hu-HU",
        "Magyar",
        "Magyar (Magyarország), Hungarian, Hungary",
        "language.hungarian",
        "hu-HU",
      ], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "mt",
    name: "Maltese",
    defaultLocale: "MT",
    welcomeBackMessage: "Merħba lura! Lest li tkompli?",
    locales: [
      ["MT", "mt-MT", "Maltese", "Maltese (Malta)", "language.maltese", "mt-MT"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "ms",
    name: "Melayu",
    defaultLocale: "MY",
    welcomeBackMessage: "Selamat kembali! Bersedia untuk teruskan?",
    locales: [["MY", "ms-MY", "Melayu", "Melayu (Malaysia)", "language.malay", "ms-MY"]],
  },
  {
    isoCode: "mn",
    name: "Mongolian",
    defaultLocale: "MN",
    welcomeBackMessage: "Дахин тавтай морил! Үргэлжлүүлэхэд бэлэн үү?",
    locales: [
      ["MN", "mn-MN", "Mongolian", "Mongolian (Mongolia)", "language.mongolian", "mn-MN"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "ne",
    name: "Nepali",
    defaultLocale: "NP",
    welcomeBackMessage: "फिर स्वागत छ! जारी राख्न तयार हुनुहुन्छ?",
    locales: [
      ["NP", "ne-NP", "Nepali", "Nepali (Nepal)", "language.nepali", "ne-NP"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "nb",
    name: "Norsk bokmål",
    defaultLocale: "NO",
    welcomeBackMessage: "Velkommen tilbake! Klar for å fortsette?",
    locales: [
      ["NO", "nb-NO", "Norsk bokmål", "Norsk bokmål (Norge)", "language.norwegian", "nb-NO"],
    ],
  },
  {
    isoCode: "uz",
    name: "O'zbek",
    defaultLocale: "UZ",
    welcomeBackMessage: "Qaytib kelishingiz bilan! Davom etishga tayyormisiz?",
    locales: [
      ["UZ", "uz-UZ", "O'zbek", "O'zbek (Uzbekistan)", "language.uzbek", "uz-UZ"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "ps",
    name: "Pashto",
    defaultLocale: "AF",
    welcomeBackMessage: "بیرته راغلاست! د دوام لپاره چمتو یاست؟",
    locales: [
      ["AF", "ps-AF", "Pashto", "Pashto (Afghanistan)", "language.pashto", "ps-AF"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "pl",
    name: "Polski",
    defaultLocale: "PL",
    welcomeBackMessage: "Witaj ponownie! Gotowy do kontynuacji?",
    locales: [["PL", "pl-PL", "Polski", "Polski (Polska), Polish", "language.polish", "pl-PL"]],
  },
  {
    isoCode: "ro",
    name: "Română",
    defaultLocale: "RO",
    welcomeBackMessage: "Bun venit înapoi! Gata să continuăm?",
    locales: [
      ["RO", "ro-RO", "Română", "Română (România)", "language.romanian", "ro-RO"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "si",
    name: "Sinhala",
    defaultLocale: "LK",
    welcomeBackMessage: "නැවත සාදරයෙන් පිළිගන්නවා! ඉදිරියට යාමට සූදානම්ද?",
    locales: [
      ["LK", "si-LK", "Sinhala", "Sinhala (Sri Lanka)", "language.sinhala", "si-LK"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "sk",
    name: "Slovenčina",
    defaultLocale: "SK",
    welcomeBackMessage: "Vitajte späť! Pripravený pokračovať?",
    locales: [
      ["SK", "sk-SK", "Slovenčina", "Slovenčina (Slovensko)", "language.slovak", "sk-SK"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "sl",
    name: "Slovenščina",
    defaultLocale: "SI",
    welcomeBackMessage: "Dobrodošli nazaj! Pripravljeni za nadaljevanje?",
    locales: [
      ["SI", "sl-SI", "Slovenščina", "Slovenščina (Slovenija)", "language.slovenian", "sl-SI"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "so",
    name: "Somali",
    defaultLocale: "SO",
    welcomeBackMessage: "Ku soo dhawaada dib! Diyaar u ah in la sii wado?",
    locales: [
      ["SO", "so-SO", "Somali", "Somali (Somalia)", "language.somali", "so-SO"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "fi",
    name: "Suomi",
    defaultLocale: "FI",
    welcomeBackMessage: "Tervetuloa takaisin! Valmis jatkamaan?",
    locales: [["FI", "fi-FI", "Suomi", "Suomi (Suomi)", "language.finnish", "fi-FI"]],
  },
  {
    isoCode: "sv",
    name: "Svenska",
    defaultLocale: "SE",
    welcomeBackMessage: "Välkommen tillbaka! Redo att fortsätta?",
    locales: [["SE", "sv-SE", "Svenska", "Svenska (Sverige)", "language.swedish", "sv-SE"]],
  },
  {
    isoCode: "vi",
    name: "Tiếng Việt",
    defaultLocale: "VN",
    welcomeBackMessage: "Chào mừng trở lại! Sẵn sàng tiếp tục chưa?",
    locales: [
      ["VN", "vi-VN", "Tiếng Việt", "Tiếng Việt (Việt Nam)", "language.vietnamese", "vi-VN"],
    ],
  },
  {
    isoCode: "tr",
    name: "Türkçe",
    defaultLocale: "TR",
    welcomeBackMessage: "Tekrar hoş geldiniz! Devam etmeye hazır mısınız?",
    locales: [
      ["TR", "tr-TR", "Türkçe", "Türkçe (Türkiye), Turkey", "language.turkish", "tr-TR"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "cy",
    name: "Welsh",
    defaultLocale: "WL",
    welcomeBackMessage: "Croeso yn ôl! Yn barod i barhau?",
    locales: [
      ["WL", "cy-GB", "Welsh", "Welsh (United Kingdom), Wales", "language.welsh", "cy-GB"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "zu",
    name: "Zulu",
    defaultLocale: "ZZ",
    welcomeBackMessage: "Sawubona futhi! Ukulungele ukuphinda?",
    locales: [
      ["ZZ", "zu-ZA", "Zulu", "Zulu (South Africa)", "language.zulu", "zu-ZA"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "el",
    name: "Ελληνικά",
    defaultLocale: "GR",
    welcomeBackMessage: "Καλώς ήρθες πάλι! Έτοιμος να συνεχίσεις;",
    locales: [
      ["GR", "el-GR", "Ελληνικά", "Ελληνικά (Ελλάδα), Greek", "language.greek", "el-GR"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "bg",
    name: "Български",
    defaultLocale: "BG",
    welcomeBackMessage: "Добре дошли отново! Готови ли сте да продължите?",
    locales: [
      [
        "BG",
        "bg-BG",
        "Български",
        "Български (България), Bulgarian",
        "language.bulgarian",
        "bg-BG",
      ], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "ru",
    name: "Русский",
    defaultLocale: "RU",
    welcomeBackMessage: "Добро пожаловать обратно! Готовы продолжить?",
    locales: [["RU", "ru-RU", "Русский", "Русский (Россия), Russian", "language.russian", "ru-RU"]],
  },
  {
    isoCode: "sr",
    name: "Српски",
    defaultLocale: "RS",
    welcomeBackMessage: "Добро дошли назад! Спремни да наставите?",
    locales: [
      ["RS", "sr-RS", "Српски", "Српски (Србија), Serbian", "language.serbian", "sr-RS"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "uk",
    name: "Українська",
    defaultLocale: "UA",
    welcomeBackMessage: "Ласкаво просимо назад! Готові продовжити?",
    locales: [
      [
        "UA",
        "uk-UA",
        "Українська",
        "Українська (Україна), Ukrainian",
        "language.ukrainian",
        "uk-UA",
      ], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "he",
    name: "עברית",
    defaultLocale: "IL",
    welcomeBackMessage: "ברוכים השבים! מוכנים להמשיך?",
    locales: [
      ["IL", "he-IL", "עברית", "Hebrew, עברית (ישראל)", "language.hebrew", "he-IL"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "fa",
    name: "فارسی",
    defaultLocale: "IR",
    welcomeBackMessage: "خوش آمدید! آماده ادامه هستید؟",
    locales: [
      ["IR", "fa-IR", "فارسی", "فارسی (ایران)", "language.persian", "fa-IR"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "am",
    name: "አማርኛ",
    defaultLocale: "ET",
    welcomeBackMessage: "እንደገና እንኳን ደህና መጡ! ለመቀጠል ዝግጁ ነዎት?",
    locales: [
      ["ET", "am-ET", "አማርኛ", "አማርኛ (ኢትዮጵያ)", "language.amharic", "am-ET"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "mr",
    name: "मराठी",
    defaultLocale: "MI",
    welcomeBackMessage: "परत स्वागत आहे! पुढे जाण्यासाठी तयार आहात?",
    locales: [
      ["MI", "mr-IN", "मराठी", "मराठी (भारत), Marathi, India", "language.marathi", "mr-IN"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "bn",
    name: "বাংলা",
    defaultLocale: "BN",
    welcomeBackMessage: "আবার স্বাগতম! এগিয়ে যেতে প্রস্তুত?",
    locales: [
      ["BN", "bn-IN", "বাংলা", "বাংলা (ভারত), Bengali, India", "language.bengali", "bn-IN"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "gu",
    name: "ગુજરાતી",
    defaultLocale: "GJ",
    welcomeBackMessage: "ફરી સ્વાગત છે! આગળ વધવા માટે તૈયાર છો?",
    locales: [
      ["GJ", "gu-IN", "ગુજરાતી", "ગુજરાતી (ભારત), Gujarati, India", "language.gujarati", "gu-IN"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "ta",
    name: "தமிழ்",
    defaultLocale: "TA",
    welcomeBackMessage: "மீண்டும் வரவேற்கிறோம்! தொடர தயாரா?",
    locales: [["TA", "ta-IN", "தமிழ்", "தமிழ் (இந்தியா), Tamil, India", "language.tamil", "ta-IN"]],
  },
  {
    isoCode: "te",
    name: "తెలుగు",
    defaultLocale: "TE",
    welcomeBackMessage: "మళ్ళీ స్వాగతం! కొనసాగించడానికి సిద్ధంగా ఉన్నారా?",
    locales: [
      ["TE", "te-IN", "తెలుగు", "తెలుగు (భారతదేశం), Telugu, India", "language.telugu", "te-IN"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "kn",
    name: "ಕನ್ನಡ",
    defaultLocale: "KA",
    welcomeBackMessage: "ಮತ್ತೆ ಸ್ವಾಗತ! ಮುಂದುವರಿಸಲು ಸಿದ್ಧರಿದ್ದೀರಾ?",
    locales: [
      ["KA", "kn-IN", "ಕನ್ನಡ", "ಕನ್ನಡ (ಭಾರತ), Kannada, India", "language.kannada", "kn-IN"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "ml",
    name: "മലയാളം",
    defaultLocale: "MB",
    welcomeBackMessage: "വീണ്ടും സ്വാഗതം! തുടരാൻ തയ്യാറാണോ?",
    locales: [
      ["MB", "ml-IN", "മലയാളം", "മലയാളം (ഇന്ത്യ), Malayalam, India", "language.malayalam", "ml-IN"], // pronunciation locale not supported
    ],
  },
  {
    isoCode: "th",
    name: "ไทย",
    defaultLocale: "TH",
    welcomeBackMessage: "ยินดีต้อนรับกลับมา! พร้อมจะดำเนินต่อไปหรือไม่?",
    locales: [["TH", "th-TH", "ไทย", "ไทย (ไทย), Thai", "language.thai", "th-TH"]],
  },
  {
    isoCode: "ko",
    name: "한국어",
    defaultLocale: "KR",
    welcomeBackMessage: "다시 돌아오신 것을 환영합니다! 계속할 준비가 되셨나요?",
    locales: [
      ["KR", "ko-KR", "한국어", "한국어(대한민국), Korean, Korea", "language.korean", "ko-KR"],
    ],
  },
  {
    isoCode: "ja",
    name: "日本語",
    defaultLocale: "JP",
    welcomeBackMessage: "おかえりなさい！続ける準備はできていますか？",
    locales: [
      ["JP", "ja-JP", "日本語", "日本語 (日本), Japanese, Japan", "language.japanese", "ja-JP"],
    ],
  },
];
